import { IonPage, IonButton, IonCardContent, IonContent, IonInput, IonItem, IonCard, IonAlert, IonLabel } from '@ionic/react';
import React, {useState} from 'react';
import axios from 'axios';
import Navbar from '../../components/Navbar';
import './Auth.css';
import { ServerUrl } from '../../constants';

const ForgetPassword: React.FC = () => {
  const [email, setEmail] = useState<string>();
  const [messageAlert, showMessageAlert] = useState<boolean>(false);

  const onSendCode = ()=> {
    if (!email){
        showMessageAlert(true);
    } else {
      axios.post(`${ServerUrl}/Auth/forgetpassword`, {username: email, password: email}).then(res => {
        alert("A reset password link has been sent to your email.")
      }).catch(err => {
        alert("Error")
      });
    };
  };

  return(
      <IonPage>
          <Navbar />
          <IonContent>
          <IonAlert 
              isOpen={messageAlert}
              onDidDismiss={()=> showMessageAlert(false)}
              header={'Error'}
              subHeader={''}
              message={'Email cannot be empty!'}
              buttons={['OK']}
          />
          <div className='Container'>
            <div className='PageTitle'>Forget Password</div>
            <IonCard>
              <IonCardContent>
                <div style={{paddingTop: '20px'}}>
                  <IonLabel>Enter your account email address to receive a verification code to reset your password.</IonLabel>
                </div>
                <IonItem className="TextInput">
                    <IonInput min='0'  value={email} placeholder="Email" 
                        onIonChange={e => setEmail(e.detail.value!)}>
                    </IonInput>
                </IonItem>
                <div className='RowCenter'>
                  <IonButton color="primary" style={{textTransform:'none'}} onClick = {onSendCode}>Send Verification Code</IonButton>
                </div>
              </IonCardContent>
            </IonCard>
          </div>
          </IonContent>
      </IonPage>
  );
};

export default ForgetPassword;
